import * as React from "react";
import { Card } from "baseui/card";
import { HeadingActionsBar } from "kanopi-components/HeadingActionBar/HeadingActionsBar";
import { useStyletron } from "kanopi-components/theme/useStyletron";
import { VerticalSpacer } from "kanopi-components/SpaceWrapper/VerticalSpacer";
import { COLOR } from "baseui/badge";

type TSummaryCardProps = {
  children: React.ReactNode;
  showHeader?: boolean;
  headerCaption?: { caption: string; captionColor: (typeof COLOR)[keyof typeof COLOR] };
  title?: string;
  ctas?: React.ReactNode[];
  "data-testid"?: string;
};
export const SummaryCard: React.FC<TSummaryCardProps> = ({
  ctas,
  showHeader = true,
  headerCaption,
  title,
  children,
  ...restProps
}) => {
  const [, theme] = useStyletron();
  return (
    <Card
      {...restProps}
      overrides={{
        Root: {
          style: {
            borderLeftWidth: 0,
            borderRightWidth: 0,
            borderTopWidth: 0,
            borderBottomWidth: 0,
            boxShadow: theme.lighting.shadow400,
            borderTopLeftRadius: theme.borders.radius300,
            borderTopRightRadius: theme.borders.radius300,
            borderBottomLeftRadius: theme.borders.radius300,
            borderBottomRightRadius: theme.borders.radius300,
          },
        },
      }}
    >
      <VerticalSpacer gap="inner-section">
        {showHeader && (
          <HeadingActionsBar
            headingLevel="section"
            heading={title}
            actions={ctas}
            {...headerCaption}
          />
        )}
        {children}
      </VerticalSpacer>
    </Card>
  );
};
